import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const SITE_NAME = import.meta.env.VITE_SITE_NAME || 'ATZ Solution LLC'
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000'
export const CONTACT_EMAIL =
  import.meta.env.VITE_CONTACT_EMAIL || 'hello@atzsolutionllc.com'
